import { FoodLogModel } from './../../../core/model/object/foodlog-model';
import {
  DietMealModel,
  MealRatio,
} from './../../../core/model/object/diet-model';
import { Component, OnInit, Input } from '@angular/core';
import { PlanService } from 'src/app/data/repository/plan-repository/plan.service';
import { DietDayModel } from 'src/app/core/model/object/diet-model';
import { PlanShared } from '../../general/shared/plan-shared';
import { CalorieCalculator } from 'src/app/utils/calorie-calculator';

@Component({
  selector: 'app-meals-table',
  templateUrl: './meals-table.component.html',
  styleUrls: ['./meals-table.component.scss'],
})
export class MealsTableComponent implements OnInit {
  @Input() isPredefined: boolean;
  @Input() dietId: string;
  @Input() dietCalorie: number;
  @Input() mealRatios: MealRatio[];
  @Input() input: DietDayModel;
  @Input() cheatDayCount: number;
  private _dataIsReady = false;
  @Input() set dataIsReady(value: boolean) {
    this._dataIsReady = value;
    if (value) {
      setTimeout(() => {
        this.updateValues();
      }, 300);
    }
  }
  get dataIsReady(): boolean {
    return this._dataIsReady;
  }

  mealTitle = ['', '', '', '', '', ''];
  sugestedCalorie = ['', '', '', '', '', ''];

  constructor(
    public planService: PlanService,
    private planShared: PlanShared,
    private calorieCalculator: CalorieCalculator
  ) {}

  ngOnInit() {}

  updateValues() {
    this.sugestedCalorie = ['', '', '', '', '', ''];
    const foodLogs = this.planShared.selectedDietDayFoodLogs.foodLogs;
    this.mealRatios.forEach((mealRatio, i) => {
      const ratio = mealRatio.ratio;
      if (ratio === 0) {
        this.sugestedCalorie[i] = 'پیشنهاد ما: ۰ کالری';
      } else {
        this.sugestedCalorie[i] =
          'پیشنهاد ما: ' +
          Math.floor(ratio * 0.01 * this.dietCalorie * 0.95).toString() +
          ' - ' +
          Math.floor(ratio * 0.01 * this.dietCalorie * 1.05).toString() +
          ' کالری';
      }
      this.mealTitle[i] =
        mealRatio.meal_text +
        ' (' +
        this.calculateCalorie(foodLogs, mealRatio.meal).toFixed(0) +
        ' کالری)';
    });
  }

  calculateCalorie(foodlogs: FoodLogModel[], meal: string): number {
    let calorie = 0;
    foodlogs.forEach((foodlog) => {
      if (foodlog.meal === meal) {
        if (foodlog.calorie && foodlog.title) {
          console.log(foodlog);

          calorie += foodlog.calorie;
        } else {
          calorie += this.calorieCalculator.calculateFoodLogCalorie(foodlog);
        }
      }
    });
    return calorie;
  }

  goToDetail(index: number) {
    this.planShared.dayStatus = this.input.isCheatDay
      ? 'cheatDay'
      : this.input.meals[0].status === 'pending' ||
        this.input.meals[0].status === 'consumed'
      ? 'diet'
      : this.input.meals[0].status;
    this.planShared.selectedMealRatio = this.mealRatios[index];
    let found = false;
    this.input.meals.forEach((meal) => {
      if (meal.meal === this.mealRatios[index].meal) {
        this.planShared.selectedMeal = meal;
        found = true;
      }
    });
    if (!found) {
      this.planShared.selectedMeal = new DietMealModel(
        '',
        '',
        this.mealRatios[index].meal,
        []
      );
      this.planShared.dayStatus = '';
    }
    this.planShared.selectedDietCalorie = this.dietCalorie;
    this.planService.goToMealDetail(
      this.dietId,
      this.input.day,
      this.isPredefined,
      this.cheatDayCount
    );
  }
}
